/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_jf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online JSON formatter, validator and minifier. Pretty-print JSON with 2/4-space or tab indentation, minify it, and get clear syntax error messages.`)
};

const es_jf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formateador, validador y minificador JSON en línea gratuito. Embellecer o minificar JSON con indentación de 2/4 espacios o tabulador, minificarlo y obtener mensajes de error de sintaxis claros.`)
};

const de_jf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-JSON-Formatter, Validator und Minimizer. Formatieren Sie JSON mit 2/4-Leerzeichen oder Tab-Einzug, minimieren Sie es, und erhalten Sie klare Fehlermeldungen zur Syntax.`)
};

const nl_jf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online JSON formatter, validator en minimaliseerder. Maak JSON mooi met 2/4-spatie of tab-inspringing, minimaliseer het, en krijg duidelijke syntaxisfouten.`)
};

const fr_jf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formateur JSON en ligne gratuit, validateur et minificateur. Embellissez le JSON avec une indentation de 2/4 espaces ou de tabulation, minifiez-le et obtenez des messages d'erreur de syntaxe clairs.`)
};

const it_jf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formattatore, validatore e minimizzatore JSON gratuiti online. Formatta JSON con indentazione a 2/4 spazi o tab, minimizzalo e ottieni messaggi di errore di sintassi chiari.`)
};

const pt_br2_jf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatador, validador e minificador JSON online gratuito. Formate JSON com 2/4 espaços ou indentação de tabulação, minifique-o e obtenha mensagens de erro de sintaxe claras.`)
};

const pt_jf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatador, validador e minificador de JSON online gratuito. Formate JSON em pretty-print com indentação de 2/4 espaços ou tabulação, minifique-o e obtenha mensagens de erro de sintaxe claras.`)
};

const ja_jf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のオンラインJSONフォーマッター、バリデーター、minifier。2スペース、4スペース、またはタブインデンテーションでJSONをきれいに整形し、minifyし、明確な構文エラーメッセージを取得します。`)
};

const zh_jf_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的在线 JSON 格式化、验证与压缩工具。使用 2/4 空格或制表符缩进美化 JSON、压缩 JSON，并获得清晰的语法错误提示。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const jf_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.jf_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("jf_meta_description", locale)
	if (locale === "en") return en_jf_meta_description(inputs)
	if (locale === "es") return es_jf_meta_description(inputs)
	if (locale === "de") return de_jf_meta_description(inputs)
	if (locale === "nl") return nl_jf_meta_description(inputs)
	if (locale === "fr") return fr_jf_meta_description(inputs)
	if (locale === "it") return it_jf_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_jf_meta_description(inputs)
	if (locale === "pt") return pt_jf_meta_description(inputs)
	if (locale === "ja") return ja_jf_meta_description(inputs)
	return zh_jf_meta_description(inputs)
};